import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";

export interface CheckExistingUserParameter extends ApiParameter {
    email: string;
    currentDateTime: string;
}

export interface CheckExistingUserModel {
    isSuccess: boolean;
    isDataFound?: boolean;
    assignedToCurrentWebsite?: boolean;
    message: string;
}

const customApiUrl = "/api/v2/UserLookup/UserCheck";

export function checkExistingUser(parameter: CheckExistingUserParameter) {
    return get<CheckExistingUserModel>(`${customApiUrl}`, parameter);
}
